<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-row>
        <el-col :span="13">
          <div class="panelContainer">
            <el-form :inline="true" :model="formInline" class="user-search">
              <el-form-item label="所属门店">
                <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
                  style="width: 140px;" @change="handleStoreChange">
                  <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                    :key="item.keyId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品编号">
                <el-input v-model="formInline.code" placeholder="请输入商品编号" clearable size="small" style="width: 140px;"
                  @change="getListData"></el-input>
              </el-form-item>
              <el-form-item label="规格：">
                <el-input style="width: 140px;" v-model="formInline.specification" placeholder="请输入规格" clearable
                  size="small"></el-input>
              </el-form-item>
              <el-form-item label="商品类型">
                <el-select v-model="formInline.typeName" placeholder="请选择商品类型" clearable filterable size="small"
                  style="width: 140px;" @change="handleTypeNameChange">
                  <el-option v-for="item in typeNameList" :label="item.value" :value="item.keyId"
                    :key="item.keyId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品名称">
                <el-select v-model="formInline.productName" placeholder="请选择商品名称" clearable filterable size="small"
                  style="width: 140px;" @change="handleProductNameChange">
                  <el-option v-for="item in productNameList" :label="item.value" :value="item.keyId"
                    :key="item.keyId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button v-if="this.$checkBtnPermission('/productInput/index', 'viewPage')" size="small"
                  type="primary" class="el-icon-search" @click="getListData()">
                  搜索
                </el-button>
              </el-form-item>
            </el-form>
            <STable :columns="columnsData" :data="listData" :loading="loading" border stripe height="511" highlight
              @row-dblclick="handleRowDoubleClick">
            </STable>
            <!-- 分页组件 -->
            <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </div>
        </el-col>
        <el-col :span="11">
          <div class="panelContainer" style="margin-left: 10px;">
            <div class="panelHeader">
              <el-row style="margin-top: 10px;">
                <el-col :span="9">
                  顾客手机号：<el-input v-model="customerSearch.customerPhone" placeholder="请输入顾客手机号" clearable size="mini"
                    style="width: 140px;"></el-input>
                </el-col>
                <el-col :span="3">
                  <el-button type="primary" class="el-icon-search" size="mini" @click="getCustomerInfo">
                    查询
                  </el-button>
                </el-col>
                <el-col :span="1">

                </el-col>
                <el-col :span="4">
                  <el-button type="danger" class="el-icon-search" size="mini" @click="showSelectCustomerDialog">
                    更多查询
                  </el-button>
                </el-col>
                <el-col :span="2" style="float: right;">
                  <el-button type="danger" class="el-icon-delete" size="mini" style="width: 100%;"
                    @click="clearSelectedGoods">清空</el-button>
                </el-col>
              </el-row>
              <el-row style="margin-top: 10px;margin-bottom: 10px;">
                <el-col :span="3">
                  顾客信息：
                </el-col>
                <el-col :span="2">
                  姓名：
                </el-col>
                <el-col :span="3">
                  <span class="showInfoSpan">{{ customerInfo.name }}</span>
                </el-col>
                <el-col :span="3">
                  会员卡号：
                </el-col>
                <el-col :span="5">
                  <span class="showInfoSpan">{{ customerInfo.vipNo }}</span>
                </el-col>
                <el-col :span="3">
                  会员余额：
                </el-col>
                <el-col :span="3">
                  <span class="showInfoSpan">{{ customerInfo.vipBalance }}</span>
                </el-col>
                <el-col :span="1">
                  元
                </el-col>
              </el-row>
            </div>
            <div class="panelContent">
              <el-table :data="listSelectedGoods" border stripe height="511" :highlight-selection-row="true"
                empty-text="请选择商品" :header-cell-style="{ borderColor: '#01e3ed', backgroundColor: '#b3e0ff' }">
                <el-table-column prop="rowNumber" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="typeName" label="类型名称" width="120" align="center"></el-table-column>
                <el-table-column prop="productName" label="商品名称" min-width="120" align="center"></el-table-column>
                <!-- <el-table-column prop="specification" label="规格" width="150" align="center"></el-table-column> -->
                <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
                <el-table-column prop="quantity" label="数量" width="80" align="center"></el-table-column>
                <el-table-column prop="price" label="价格（元）" width="100" align="center"></el-table-column>
                <el-table-column prop="money" label="金额" width="100" align="center"></el-table-column>
              </el-table>
            </div>
            <div class="panelFooter">
              <el-row style="margin-top: 10px;">
                <el-col :span="5">
                  总金额：<span style="font-size: 20px; color: red; font-weight: bold; margin-right: 10px;">{{ totalMoney
                  }}</span>元
                </el-col>
                <el-col :span="1">

                </el-col>
                <el-col :span="5">
                  总数量：<span style="font-size: 20px; color: red; font-weight: bold; margin-right: 10px;">{{ totalQuantity
                  }}</span>个
                </el-col>
                <el-col :span="13">

                </el-col>
              </el-row>
              <el-row style="margin-top: 10px;">
                <el-col :span="24">
                  <el-button type="warning" class="el-icon-check" style="width: 100%;" @click="showPayDialog">结
                    算</el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </topTab>
    <selectCustomer ref="selectCustomer"></selectCustomer>
    <!-- 销售订单结算弹窗 -->
    <el-dialog :visible.sync="dialogVisible" title="销售订单结算" append-to-body :close-on-click-modal="false">
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>订单来源:</strong></span>
      <el-select v-model.number="saleInfo.orderSource" placeholder="请选择订单来源" clearable filterable size="small"
        style="width: 100%;">
        <el-option v-for="item in orderSourceList" :label="item.value" :value="item.keyId"
          :key="item.keyId"></el-option>
      </el-select>
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>商品总金额:</strong></span>
      <el-input v-model.number="totalMoney" placeholder="请输入商品总金额" style="width: 100%;" disabled
        size="small"></el-input>
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>订单金额:</strong></span>
      <el-input v-model.number="saleInfo.totalMoney" placeholder="请输入订单金额" style="width: 100%;" size="small"></el-input>
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>总付款金额:</strong></span>
      <el-input v-model.number="saleInfo.totalPayMoney" placeholder="请输入总付款金额" style="width: 100%;"
        size="small"></el-input>
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>支付方式:</strong></span>
      <el-select v-model.number="saleInfo.payType.payTypeId" placeholder="请选择支付方式" clearable filterable size="small"
        style="width: 100%;">
        <el-option v-for="item in payTypeList" :label="item.payTypeName" :value="item.payTypeId"
          :key="item.payTypeId"></el-option>
      </el-select>
      <span style="display: block; margin-bottom: 10px"><strong><i style="color: red;">*</i>支付金额:</strong></span>
      <el-input v-model.number="saleInfo.payType.payMoney" placeholder="请输入支付金额" style="width: 100%;"
        size="small"></el-input>
      <span style="display: block; margin-bottom: 10px"><strong>支付备注:</strong></span>
      <el-input v-model="saleInfo.payType.payComment" placeholder="请输入支付备注" style="width: 100%;"
        size="small"></el-input>
      <span slot="footer">
        <el-button @click="dialogVisible = false" icon="el-icon-close" size="small">取消</el-button>
        <el-button type="primary" icon="el-icon-finished" size="small" :loading="isSubmitting"
          @click="handleSubmitSalesOrder">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetStoreProductPageList,
  SaveSalesOrder,
  GetProductTypeNameList,
  GetProductTypeSubNameList,
} from "@/api/productApi.js";
import {
  GetUserBindSelectByPermission
} from "@/api/userApi.js";
import {
  GetCustomerVipInfo
} from "@/api/baseDataApi.js";
import {
  GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import selectCustomer from "@/views/baseData/customer/selectCustomer.vue";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "商品销售",
        }
      ],
      loading: false, // 显示加载
      pageShow: true,
      listData: [],
      userList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        storeKeyId: "",
        typeName: "",
        productName: "",
        code: "",
        specification: "",
      },
      isSubmitting: false, // 防重复提交标志
      columnsData: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          width: "60",
          isKeep: true,
        },
        {
          prop: "storeName",
          label: "门店名称",
          isKeep: true,
          width: "120",
          align: "center",
        },
        // {
        //   prop: "productInfo.code",
        //   label: "商品编码",
        //   isKeep: true,
        //   minWidth: "170",
        //   align: "center",
        // },
        {
          prop: "productInfo.typeName",
          label: "类型名称",
          width: "100",
          align: "center",
        },
        {
          prop: "productInfo.productName",
          label: "商品名称",
          minWidth: "180",
          align: "center",
        },
        {
          prop: "productInfo.specification",
          label: "规格",
          width: "100",
          align: "center",
        },
        {
          prop: "productInfo.unit",
          label: "单位",
          width: "60",
          align: "center",
        },
        {
          prop: "price",
          label: "价格（元）",
          width: "100",
          align: "center",
        },
        {
          prop: "quantity",
          label: "库存数量",
          width: "80",
          align: "center",
        },
      ],
      listSelectedGoods: [],
      totalMoney: 0,
      totalQuantity: 0,
      customerInfo: {
        name: "",
        phone: "",
        vipNo: "",
        vipBalance: 0,
      },
      customerSearch: {
        storeKeyId: "",
        customerPhone: "",
        customerKeyId: "",
      },
      storeList: [],
      saleInfo: {
        payType: {
          payTypeId: 1,
          payMoney: 0,
          payComment: "",
        },
        customerKeyId: "",
        dtls: [],
        storeKeyId: "",
        totalMoney: 0,
        totalPayMoney: 0,
        orderSource: 1,
        remark: "",
      },
      dialogVisible: false,
      payTypeList: [],
      isSubmit: false,
      orderSourceList: [],
      typeNameList: [],
      productNameList: [],
    };
  },
  // 注册组件
  components: {
    selectCustomer
  },
  created() {
    this.GetOrgInfoListByConfig();
    this.GetUserBindSelectByPermission();
    this.GetEnumConfigListByCode();
    this.GetOrderSourceConfigListByCode();
    this.getProductTypeNameList();
    this.getProductTypeSubNameList(this.formInline.typeName);
  },
  computed: {},
  methods: {
    changePages() { },
    // 获取列表
    getListData() {
      if (!this.formInline.storeKeyId) {
        this.$message.error("请选择门店！");
        return;
      }
      this.loading = true;
      GetStoreProductPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            if (res.code == 1) {
              res.data.forEach((item) => {
                this.storeList.push({
                  keyId: item.keyId,
                  value: item.name + '【' + item.remark2 + '】',
                });
              });
              this.formInline.storeKeyId = this.storeList[0].keyId;
              this.getListData();
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 获取员工列表信息
    GetUserBindSelectByPermission() {
      GetUserBindSelectByPermission({})
        .then((res) => {
          if (res.code == 1) {
            this.userList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("获取员工列表失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 处理左侧表格双击事件
    handleRowDoubleClick(row) {
      // 创建商品数据对象
      const productData = {
        rowNumber: this.listSelectedGoods.length + 1,
        keyId: row.keyId,
        typeName: row.productInfo.typeName,
        productName: row.productInfo.productName,
        unit: row.productInfo.unit,
        quantity: 1,
        price: parseFloat(row.price),
        money: parseFloat(row.price)
      };

      // 查找是否已存在相同商品
      const existingIndex = this.listSelectedGoods.findIndex(
        item => item.keyId === productData.keyId
      );

      if (existingIndex >= 0) {
        // 如果商品已存在，增加数量并重新计算金额
        this.listSelectedGoods[existingIndex].quantity += 1;
        this.listSelectedGoods[existingIndex].money = this.listSelectedGoods[existingIndex].price * this.listSelectedGoods[existingIndex].quantity;
      } else {
        // 如果商品不存在，添加到右侧表格
        this.listSelectedGoods.push(productData);
      }
      var totalMoney = 0;
      var totalQuantity = 0;
      // 更新序号
      this.listSelectedGoods.forEach((item, index) => {
        item.rowNumber = index + 1;
        totalMoney += item.money;
        totalQuantity += item.quantity;
      });
      this.totalMoney = totalMoney;
      this.totalQuantity = totalQuantity;
      this.saleInfo = {
        payType: {
          payTypeId: 1,
          payMoney: totalMoney,
          payComment: "",
        },
        customerKeyId: "",
        dtls: [],
        storeKeyId: "",
        totalMoney: totalMoney,
        totalPayMoney: totalMoney,
        orderSource: 1,
        remark: "",
      };
    },
    // 清空选中商品
    clearSelectedGoods() {
      this.listSelectedGoods = [];
      this.totalMoney = 0;
      this.totalQuantity = 0;
      this.saleInfo = {
        payType: {
          payTypeId: 1,
          payMoney: 0,
          payComment: "",
        },
        customerKeyId: "",
        dtls: [],
        storeKeyId: "",
        totalMoney: 0,
        totalPayMoney: 0,
        orderSource: 1,
        remark: "",
      };
    },
    // 获取客户信息
    getCustomerInfo() {
      if (!this.customerSearch.customerPhone && !this.customerSearch.customerKeyId) {
        this.$message.error("请输入客户手机号或选择客户！");
        return;
      }
      this.customerSearch.storeKeyId = this.formInline.storeKeyId;
      if (!this.customerSearch.storeKeyId && !this.customerSearch.customerKeyId) {
        this.$message.error("请选择门店！");
        return;
      }
      this.customerInfo = {
        name: "",
        phone: "",
        vipNo: "",
        vipBalance: 0,
      };
      this.loading = true;
      GetCustomerVipInfo(this.customerSearch)
        .then((res) => {
          if (res.code == 1) {
            this.customerInfo.name = res.data.customerInfo.name;
            this.customerInfo.phone = res.data.customerInfo.phone;
            if (res.data.vipNo) {
              this.customerInfo.vipNo = res.data.vipNo;
            }
            if (res.data.balance) {
              this.customerInfo.vipBalance = res.data.balance;
            }
            else {
              this.customerInfo.vipBalance = 0;
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("获取客户信息失败，请稍后再试！");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //获取支付类型信息
    GetEnumConfigListByCode() {
      const paramer = {
        code: "PayType",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.payTypeList = [];
            res.data.forEach((item) => {
              this.payTypeList.push({
                payTypeId: parseInt(item.code),
                payTypeName: item.name,
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取状态信息失败!");
        });
    },
    //获取订单来源信息
    GetOrderSourceConfigListByCode() {
      const paramer = {
        code: "StoreOrderSource",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.orderSourceList = [];
            res.data.forEach((item) => {
              this.orderSourceList.push({
                keyId: parseInt(item.code),
                value: item.name,
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取订单来源信息失败!");
        });
    },
    // 处理门店选择变化
    handleStoreChange(val) {
      this.formInline.storeKeyId = val;
      this.clearSelectedGoods();
      this.getListData();
    },
    // 显示选择客户弹窗
    showSelectCustomerDialog() {
      var storeKeyId = this.formInline.storeKeyId;
      if (!storeKeyId) {
        this.$message.error("请选择门店！");
        return;
      }
      this.$refs.selectCustomer.showSelectCustomerDialog(storeKeyId);
    },
    // 选择客户
    chooseCustomer(val) {
      this.customerSearch.customerKeyId = val;
      this.getCustomerInfo();
    },
    // 显示支付弹窗
    showPayDialog() {
      this.dialogVisible = true;
    },
    // 处理提交支付
    handleSubmitSalesOrder() {
      if (!this.customerSearch.customerKeyId) {
        this.$message.error("请选择客户！");
        return;
      }
      this.saleInfo.customerKeyId = this.customerSearch.customerKeyId;
      this.saleInfo.storeKeyId = this.formInline.storeKeyId;
      if (!this.saleInfo.payType.payTypeId) {
        this.$message.error("请选择支付类型！");
        return;
      }
      if (!this.saleInfo.payType.payMoney) {
        this.$message.error("请输入支付金额！");
        return;
      }
      // if (this.saleInfo.payType.payMoney > this.customerInfo.vipBalance) {
      //   this.$message.error("支付金额不能大于客户余额！");
      //   return;
      // }
      this.isSubmitting = true;
      var products = [];
      this.listSelectedGoods.forEach((item) => {
        products.push({
          storeProductKeyId: item.keyId,
          quantity: item.quantity
        });
      });
      this.saleInfo.dtls = products;
      SaveSalesOrder(this.saleInfo)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("支付成功！");
            this.dialogVisible = false;
            this.getCustomerInfo();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("支付失败，请稍后再试！");
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    // 处理类型名称改变
    handleTypeNameChange(val) {
      this.formInline.productName = "";
      this.getProductTypeSubNameList(val);
      this.getListData();
    },
    // 处理商品名称改变
    handleProductNameChange(val) {
      this.formInline.productName = val;
      this.getListData();
    },
    getProductTypeNameList() {
      GetProductTypeNameList({}).then(res => {
        if (res.code == 1) {
          this.typeNameList = [];
          if (res.code == 1) {
            res.data.forEach((item) => {
              this.typeNameList.push({
                keyId: item.value,
                value: item.value,
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getProductTypeSubNameList(code) {
      var params = {
        code: code,
      };
      GetProductTypeSubNameList(params).then((res) => {
        if (res.code == 1) {
          this.productNameList = [];
          if (res.code == 1) {
            res.data.forEach((item) => {
              this.productNameList.push({
                keyId: item.value,
                value: item.value,
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  }
};
</script>

<style scoped lang="scss">
.panelContainer {
  border-radius: 15px;
  height: 720px;
  background-color: #fff;
  margin-top: 10px;
  padding: 20px;
}

.panelFooter {
  margin-top: 20px;
}

.showInfoSpan {
  color: red;
  text-align: center;
  height: 24px !important;
  display: grid;
  align-items: center;
}
</style>